var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCplusplusWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{opacity:0.7;fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256,196c-33.1,0-60,26.9-60,60c0,10.9,2.9,21.2,8.1,30l51.9-30l52-30C297.3,207.5,277.3,196,256,196z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256,136c42.7,0,82.5,23,103.9,60l-30.4,17.6l101.9-58.8c-2.8-4.9-6.7-9.2-11-11.6L271.6,57.2 c-8.6-5-22.6-5-31.2,0L91.6,143.1C83,148,76,160.2,76,170.1v171.8c0,5,1.8,10.5,4.6,15.4l71.5-41.3c-10.2-17.7-16.1-38.1-16.1-60 C136,189.8,189.8,136,256,136z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M359.9,316c-21.4,37-61.2,60-103.9,60c-44.3,0-83.1-24.2-103.9-60l-71.5,41.3c2.8,4.9,6.7,9.2,11,11.6 l148.8,85.9c8.6,5,22.6,5,31.2,0l148.8-85.9c4.3-2.5,8.2-6.7,11-11.6l-97.3-56.2L359.9,316z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256,316c21.3,0,41.3-11.5,52-30l-52-30l-51.9,30C214.5,303.9,233.8,316,256,316z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M431.4,154.7l-102.2,59L308,226c0,0,0,0,0,0l-52,30l52,30c0,0,0,0,0,0l26.1,15.1l97.3,56.2 c2.8-4.9,4.6-10.4,4.6-15.4V170.1C436,165.1,434.2,159.6,431.4,154.7z M376,262.7h-13.3V276h-13.3v-13.3H336v-13.3h13.3V236h13.3 v13.3H376V262.7z M426,262.7h-13.3V276h-13.3v-13.3H386v-13.3h13.3V236h13.3v13.3H426V262.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M308,286l26.2,15.1L308,286C308,286,308,286,308,286z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M308,226l21.2-12.3L308,226C308,226,308,226,308,226z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCplusplusWhite);
export default __webpack_public_path__ + "static/media/cplusplus-white.76d1d82697034862ffe9f37abfa57314.svg";
export { ForwardRef as ReactComponent };